export default __webpack_public_path__ + "static/poster_01-8c0a98f38e5ac365d5c3f5c83139e7bd.png";